/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgDropOffLocation56(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={56}
      height={56}
      fill='none'
      viewBox='0 0 56 56'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M12.25 6.25a4.25 4.25 0 100 8.5 4.25 4.25 0 000-8.5zM9.5 10.5a2.75 2.75 0 115.5 0 2.75 2.75 0 01-5.5 0z'
      />
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M11.793 25.062l.497-.562-.497.562c.284.25.71.25.993 0l-.496-.562.496.562.002-.002.006-.005.02-.018a18.27 18.27 0 00.365-.333 45.42 45.42 0 004.087-4.359c1.117-1.368 2.249-2.944 3.104-4.576.852-1.624 1.46-3.361 1.46-5.035C21.83 5.185 17.563 1 12.29 1c-5.275 0-9.54 4.185-9.54 9.734 0 1.674.608 3.41 1.46 5.034.855 1.633 1.987 3.21 3.104 4.577a45.413 45.413 0 004.374 4.623l.033.03.044.039.02.018.008.007zM4.25 10.734c0-4.732 3.605-8.234 8.04-8.234 4.434 0 8.04 3.502 8.04 8.234 0 1.33-.491 2.818-1.288 4.338-.793 1.512-1.858 3.002-2.938 4.324a43.918 43.918 0 01-3.814 4.085 43.934 43.934 0 01-3.814-4.085c-1.08-1.322-2.146-2.812-2.938-4.324-.797-1.52-1.288-3.007-1.288-4.338z'
      />
      <path
        fill='currentColor'
        d='M28.48 13.012A9.889 9.889 0 0028 13a.75.75 0 010-1.5c.185 0 .369.005.552.013l.749.037-.073 1.498-.749-.036zM31.286 13.567l-.706-.252.505-1.413.706.253c.348.125.689.266 1.02.423l.678.321-.642 1.356-.678-.321a9.67 9.67 0 00-.883-.367zM34.547 15.525l-.555-.503L35 13.91l.555.503c.273.248.533.508.78.78l.505.556-1.112 1.008-.504-.555a9.782 9.782 0 00-.676-.678zM36.816 18.58l-.32-.677 1.355-.642.32.678c.158.331.3.671.424 1.02l.253.706-1.413.505-.252-.706a9.67 9.67 0 00-.367-.883zM37.738 22.27l-.036-.748 1.498-.073.037.75c.008.182.013.366.013.551v1.188h-1.5V22.75c0-.16-.004-.32-.012-.48zM37.75 25.063h1.5v2.375h-1.5v-2.375zM37.75 28.563h1.5v1.187a.75.75 0 01-1.5 0v-1.188zM38.265 40.218l5.531 5.542 1.062-1.06-5.533-5.544 5.534-5.546-1.062-1.06-5.532 5.544-5.532-5.544-1.061 1.06 5.534 5.546-5.534 5.545 1.062 1.06 5.531-5.544z'
      />
      <path
        fill='currentColor'
        d='M25.308 4.25H51.75v47.5H4.25V24.5h-1.5v28c0 .414.336.75.75.75h49a.75.75 0 00.75-.75v-49a.75.75 0 00-.75-.75H25.308v1.5z'
      />
    </svg>
  );
}

export default SvgDropOffLocation56;
